export default __webpack_public_path__ + "static/media/landingvideo.203010d7.mov";